import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useFreightTFunction } from '@retail/freight/i18n';
import { HelperText } from '@shared/components';
import { FieldError } from 'react-hook-form';

const fixedAddon = 'fixed_addon';
const percent = 'percent';
interface Props {
  error?: FieldError;
  value: string;
  handleSelectFreightType: (type: string) => void;
}

export function SelectFreightTypeRadio({ error, value, handleSelectFreightType }: Props) {
  const t = useFreightTFunction();

  return (
    <FormControl required error={!!error}>
      <FormLabel>{t('freight.form.freightType')}:</FormLabel>
      <RadioGroup sx={{ pl: 1, display: 'flex', flexDirection: 'row', gap: 2 }}>
        <FormControlLabel
          control={
            <Radio checked={value === percent} onClick={() => handleSelectFreightType(percent)} />
          }
          label={<Typography variant="subtitle2">{t('freight.form.percent')}</Typography>}
        />
        <FormControlLabel
          control={
            <Radio
              checked={value === fixedAddon}
              onClick={() => handleSelectFreightType(fixedAddon)}
            />
          }
          label={<Typography variant="subtitle2">{t('freight.form.fixedAddon')}</Typography>}
        />
      </RadioGroup>
      {error && (
        <HelperText id="freightTypeError" status="error">
          {error.message}
        </HelperText>
      )}
    </FormControl>
  );
}
